import { Alert } from "@mui/material";
import type { ReactElement } from "react";
import { type FieldError, type Merge } from "react-hook-form";

export type ChildError<T> = Merge<FieldError, T>;

export const TopLevelErrorAlert = <T,>({
  errors,
}: {
  errors?: (ChildError<T> | undefined)[];
}): ReactElement => {
  return (
    <>
      {errors &&
        errors.map((error: ChildError<T> | undefined, index: number) => {
          return (
            typeof error?.message === "string" && (
              <Alert severity="error" sx={{ mt: 3 }} key={`alert-${index}`}>
                {error.message}
              </Alert>
            )
          );
        })}
    </>
  );
};
